module.exports = __webpack_public_path__ + "img/timer-start-outline.41c1f344.svg";